<template>
  <div
    class="hero"
    :style="{
      backgroundImage: `url(${require(`@/assets/img/background.png`)})`,
    }"
  >
    <div class="hero__container">
      <div class="hero__content">
        <h1>{{ data.h1Plain }} {{ data.h1Bold }}</h1>
        <p v-html="data.paragraph"></p>
      </div>
      <div class="hand-container">
        <img
          :src="require(`@/assets/heroes_web/${heroImage}.png`)"
          alt=""
          class="hand_img"
        />
      </div>
    </div>
  </div>
  <img
    :src="require(`@/assets/heroes_mob/${heroImage}.png`)"
    alt=""
    class="hero__image"
  />
</template>

<script>
import { ref } from "vue";
import Content from "../data/content";

export default {
  name: "HeroSection",
  setup() {
    const lang = process.env.VUE_APP_LOCALITY;
    const data = ref(Content[lang].hero);
    const heroImage = ref(lang);

    return { data, heroImage };
  },
};
</script>

<style>
.hero {
  background: center center / cover no-repeat;
}

.hero__container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  max-width: 1126px;
  margin: 0 auto;
}

.hero__content {
  max-width: 50%;
}

.hero p {
  color: #1e1e1e;
  font-family: "JETSansDigital", sans-serif;
  font-size: 20px;
  font-weight: 400;
  line-height: 28px;
}

.hand_img {
  width: 100%;
  height: auto;
}

.hand-container {
  max-width: 700px;
  align-self: flex-end;
  max-height: 695px;
  margin-left: auto;
  margin-right: -80px;
}

.hero__image {
  display: none;
  max-width: 100%;
  height: 50vh;
  min-height: 500px;
  width: auto;
  object-fit: cover;
  object-position: 87%;
}

@media only screen and (max-width: 992px) {
  .hand-container {
    display: none;
  }

  .hero {
    background-color: #ffffff;
    background-image: none !important;
    padding: 0;
  }
  .hero__container {
    padding: 40px 15px 20px 30px;
  }
  .hero__content {
    max-width: 100%;
  }

  .hero__content h1 {
    font-size: 32px;
    line-height: 32px;
    text-align: center;
  }

  .hero p {
    font-size: 20px;
    text-align: center;
  }

  .hero__image {
    display: block;
    width: 100%;
  }
}

@media only screen and (max-width: 1200px) {
  .hero__container {
    padding: 40px 15px 0 30px;
  }
}
</style>
